/**
 * スムーススクロール
 * スムーススクロールをさせない場合は「js-notScroll」クラスをつける
 */
export default function() {
  
  jQuery(function($){
    $(`a[href^='#']:not('.js-notScroll')`).on(`click`, function(e){
      // clickのブラウザデフォルト挙動を防ぐ
      e.preventDefault()

      const speed_ms = 500
      const href= $(this).attr(`href`)
      const target = $(href == `#` || href == `` ? `html` : href)
      const position = target.offset().top
      $(`html, body`).animate({scrollTop:position}, speed_ms, `swing`)
    })
  })
}
